/**
 * @generated SignedSource<<d4060c0d9d7c0e8f2caed04dfb1a77a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConnectedWalletRespMenu_user$data = {
  readonly ethereumWalletAddress: {
    readonly address: string | null;
    readonly ensDomain: string | null;
    readonly publicProfile: {
      readonly username: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftAvatarCircle_address">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectedWalletMenuContent_user">;
  readonly " $fragmentType": "ConnectedWalletRespMenu_user";
};
export type ConnectedWalletRespMenu_user$key = {
  readonly " $data"?: ConnectedWalletRespMenu_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectedWalletRespMenu_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectedWalletRespMenu_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectedWalletMenuContent_user"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "ethereumWalletAddress",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftAvatarCircle_address"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ensDomain",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "565658862050a9cb7c2655f24e34b3d9";

export default node;
